<template>
  <v-layout row>
  <v-btn fab small @click="minus">-</v-btn>
  <v-text-field
    v-show="show"
    :label="label || title"
    v-model="val"
    :rules="rules"
    :required="required||false"
  ></v-text-field>
  <v-btn fab small @click="plus">+</v-btn>
  </v-layout>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';

export default {
  mixins: [EventMixin],
  props: [
    'value',
    'name',
    'label',
    'title',
    'required'
  ],
  methods: {
    check_val () {
      if (_.isEmpty(this.val)) {
        this.val = "0";
      }
    },
    plus () {
      this.check_val();
      this.val = parseInt(this.val, 10) + 1;
    },
    minus () {
      this.check_val();
      this.val = parseInt(this.val, 10) - 1;
    }
  },
  computed: {
    rules () {
      if(this.required) {
        return [
          v => !!v || this.label+' is required'
        ]
      }
      return [];
    },
    val: {
      get () {
        return _.get(this.value, this.name) || "0";
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
